module.exports = __webpack_public_path__ + "img/chunenggui_s.1c3edb23.png";